import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "components/table/Table";
import { AddButton, MediumScreenModel } from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { featchFeaturedAds } from "../state/action";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import HandleCreateFeaturedAds from "./HandleCreateFeaturedAds";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const PackagesTable: React.FC<Props> = ({ onFetchFeaturedAds, featuredAdsState }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(!isModalOpen);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchFeaturedAds();
  }, [onFetchFeaturedAds]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_FEATURED_ADS));
  const featuredData = featuredAdsState?.featuredAds
  return (
    <div className="">
      <Table
        headers={["Featured Ads"]}
        data={featuredData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add Featured Ads"
                tooltip="Add new featured ads"
              />
            )}
          </>
        }
      />
      <MediumScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleCreateFeaturedAds onClose={closeModal} />
        </div>
      </MediumScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    featuredAdsState: state.featuredAds?.featuredAdsState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchFeaturedAds: () => dispatch(featchFeaturedAds()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackagesTable);
